import React, {Fragment} from 'react';
import Notification from '../views/notificationItem.c';
import '../less/notifications.less';

export default function template() {
    let {notifications = []} = this.props,
        content;

    if (notifications.length) {
        content = (
            <div className="module-notifications">
                {notifications.map(item => (
                    <Notification key={item.id} isError={item.isError}>
                        {item.value}
                    </Notification>
                ))}
            </div>
        );
    }

    return (
        <Fragment>
            {content}
            {this.props.children}
        </Fragment>
    );
}
